import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { showCRMFailureToastWithGivenMessage } from '@flowwai-frontend/bps-officer-web/common/ui'

import { useUserAppConfigStore } from '../../hooks/stores/useUserAppConfigStore'
import { ClockOutMutation as Mutation } from './mutation.generatedTypes'

interface ReturnType {
   handleAPIResponse: (response: Mutation, onSuccess?: () => void) => void
}

const useResponseHandler = (): ReturnType => {
   const commonT = useCustomT('common:common')
   const t = useCustomT('common:attendance')
   const userAppConfigStore = useUserAppConfigStore()

   const handleAPIResponse = (
      response: Mutation,
      onSuccess?: () => void
   ): void => {
      const { clockOut } = response

      switch (clockOut.__typename) {
         case 'ClockOutResult': {
            const userModel = userAppConfigStore.userDetails
            if (userModel) {
               userModel.setAttendance({
                  clockIn: null
               })
            }

            onSuccess?.()
            break
         }

         case 'ClockInNotAttempted': {
            const userModel = userAppConfigStore.userDetails
            if (userModel) {
               userModel.setAttendance({
                  clockIn: null
               })
            }
            showCRMFailureToastWithGivenMessage(
               clockOut.message || t('clockInNotAttempted')
            )
            onSuccess?.()
            break
         }

         case 'FeatureNotEnabled':
            showCRMFailureToastWithGivenMessage(t('featureNotEnabled'))
            userAppConfigStore.permissions.setIsAttendanceTrackingEnabled(false)
            onSuccess?.()
            break

         default:
            showCRMFailureToastWithGivenMessage(commonT('errorViewTitle'))
      }
   }

   return {
      handleAPIResponse
   }
}

export default useResponseHandler
